import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { components } from "../../components";
import { useQueryTransactions } from "../../graphql/apollo/useQuery";
import AuthLayout from "../../services/auth/jwt/withAuth";
import { text } from "../../text";
import { utils } from "../../utils";
import { theme } from "../../constants";
import { simpleDate } from "../../utils/dateUtils";
import { TRANSACTION } from "../../constants/constants";
import { AccountIcon, WithdrawMoneyIcon } from "../../constants/icons";

export const TransactionsScreen: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { transactions } = useQueryTransactions(undefined);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const renderIcon = (action: string) => {
    if (action === TRANSACTION.TOPUP) {
      return <AccountIcon size={30} />;
    } else {
      return <WithdrawMoneyIcon size={30} />;
    }
  };

  const renderTitle = (action: string) => {
    if (action === TRANSACTION.TOPUP) {
      return <span>{t("recharge")}</span>;
    } else {
      return <span>{t("withdraw")}</span>;
    }
  };

  return (
    <AuthLayout>
      <components.Header
        themeColor="light"
        title={t("fundDetail")}
        goBack={true}
      />
      <main
        style={{ paddingBottom: 0, paddingTop: 50 }}
        className="transactions"
      >
        <div style={{ margin: 30 }}>
          {transactions.map((transaction, index) => {
            return (
              <div
                key={index}
                style={{
                  width: "100%",
                  backgroundColor: "#FFF7F2",
                  borderRadius: 10,
                  padding: "20px 18px",
                  cursor: "pointer",
                  userSelect: "none",
                  marginBottom: 10,
                  ...utils.rowCenter(),
                }}
              >
                {renderIcon(transaction.action)}
                <div style={{ marginLeft: 12, marginRight: "auto" }}>
                  <div style={{ fontSize: 20, marginBottom: 1 }}>
                    {transaction.amount}{" "}
                    <span
                      style={{
                        ...theme.fonts.Lato_400Regular,
                        fontSize: 14,
                        textTransform: "uppercase",
                        color: theme.colors.mainColor,
                      }}
                    >
                      $
                    </span>
                  </div>
                  <text.T14>{simpleDate(transaction.createdAt)}</text.T14>
                </div>
                <text.T14
                  style={{
                    ...theme.fonts.Lato_400Regular,
                    color: theme.colors.mainColor,
                  }}
                >
                  {renderTitle(transaction.action)}
                </text.T14>
              </div>
            );
          })}
        </div>
      </main>
    </AuthLayout>
  );
};
